import { MIN_PRIORITY_0, MAX_PRIORITY_100 } from 'constants/validation';

/**
 * Utility class for validation handling
 */
export const isEmailValid = (value) => {
  if (value) {
    const emailMatch = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    return emailMatch && emailMatch.length > 0;
  }
  return false;
};

export const isNameValid = (value) => {
  if (value) {
    return value.length > 0;
  }
  return false;
};

export const isValueEntered = (value) => {
  if (value) {
    return value !== null && value !== undefined && value !== '';
  }
  return false;
};

/**
 * Check the value is a number greater than or equal to the min and less than or equal to the max values specified
 * @param {*} value 
 * @param {*} min 
 * @param {*} max 
 */
export const isNumberEnteredValid = (value, min, max) => {
  if (isNumberValid(value) && (value >= min && value <= max)) {
    return true;
  }
  return false;
};

/**
 * Check the value is a number greater than or equal to 0 and less than or equal to 100
 * @param {*} value 
 * @param {*} min 
 * @param {*} max 
 */
export const is0to100NumberValid = (value) => {
  if (isNumberValid(value) && (value >= MIN_PRIORITY_0 && value <= MAX_PRIORITY_100)) {
    return true;
  }
  return false;
};

/**
 * Check the value is a number
 * @param {*} value 
 */
export const isNumberValid = (value) => {
  if (value !== null && value !== undefined && !isNaN(value) && typeof value == 'number') {
    return true;
  }
  return false;
};

/**
 * checks if the entry is empty - space, 0, null, undefined
 * @param {*} e 
 */
export const isEmpty = (e) => {
  switch (e) {
    case '':
    case null:
    case typeof(e) == 'undefined':
    case undefined:
      return true;
    default:
      return false;
  }
};



// WEBPACK FOOTER //
// ./services/Validation.js